/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/alt-text */
import React, { Component, Fragment } from "react";
import {
  Form,
  Input,
  Table,
  Modal,
  Radio,
  DatePicker,
  Spin,
} from "antd";
import Cookies from "js-cookie";
import moment from "moment";
import { Ui, Translate } from "../../../services";
import Api from "../../../services/ServiceApi";
class JobCategory extends Component {
  formRef = React.createRef();
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      visible: false,
      visible_approve: false, // for opening and closing of approve modal
      visible_reject: false,
      visible_delete: false,
      loading_modal_delete: false,
      title: "Job Category",
      data: [],
      data_item: [],
      modal_item: {},
      // render: (item) => (!item.group_type_id? "-" : item.group_type_id),

      columns: [
        {
          title: () => <Translate text="th_job_category_id" />,
          render: (item) =>
            !item.job_category_id ? "-" : item.job_category_id,
          align: "center",
          key: "job_category_id",
          sorter: (a, b) => 
          (a.job_category_id === null || a.job_category_id  === undefined ? 0 : a.job_category_id) -  
          (b.job_category_id === null || b.job_category_id  === undefined ? 0 : b.job_category_id),
        },
        {
          title: () => <Translate text="th_job_category_name" />,
          render: (item) =>
            !item.job_category_name ? "-" : item.job_category_name,
          align: "center",
          key: "job_category_name",
          sorter: (a, b) =>
          (a.job_category_name === null || a.job_category_name  === undefined ? "": a.job_category_name).localeCompare
          (b.job_category_name === null || b.job_category_name  === undefined ? "": b.job_category_name),
        },
        {
          title: () => <Translate text="th_create_by" />,
          render: (item) => (!item.create_name ? "-" : item.create_name),
          align: "center",
          key: "create_name",
          sorter: (a, b) =>
          (a.create_name === null || a.create_name  === undefined ? "": a.create_name).localeCompare
          (b.create_name === null || b.create_name  === undefined ? "": b.create_name),
        },
        {
          title: () => <Translate text="th_effective_date" />,
          align: "center",
          key: "effective_date",
          render: (item) =>
            !item.effective_date ? (
              "-"
            ) : (
              <div>{moment(item.effective_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) =>
            (a.effective_date === null || a.effective_date  === undefined ? "": a.effective_date).localeCompare
            (b.effective_date === null || b.effective_date  === undefined ? "": b.effective_date),
        },
        {
          title: () => <Translate text="th_expired_date" />,
          align: "center",
          key: "expire_date",
          render: (item) =>
            !item.expire_date ? (
              "-"
            ) : (
              <div>{moment(item.expire_date).format("DD/MM/YYYY")}</div>
            ),
            sorter: (a, b) =>
            (a.expire_date === null || a.expire_date  === undefined ? "": a.expire_date).localeCompare
            (b.expire_date === null || b.expire_date  === undefined ? "": b.expire_date),
        },
        {
          title: () => <Translate text="th_status" />,
          align: "center",
          key: "is_active",
          render: (item) => (
            <div>
              {item === 0 ? (
                <span className="c-red">
                  <span className="dot-Inactive mr-2"></span>InActive
                </span>
              ) : (
                <span className="c-green">
                  <span className="dot-active mr-2"></span>Active
                </span>
              )}
            </div>
          ),
          sorter: (a, b) =>
          (a.is_active === null || a.is_active  === undefined ? 0: a.is_active) -
          (b.is_active === null || b.is_active  === undefined ? 0: b.is_active),
        },
        {
          title: () => <Translate text="th_action" />,
          align: "center",
          key: "",
          render: (item) => (
            <div>
              <a onClick={() => this.onModal("edit", true, item)}>
                <img src={Api.absoluteUrl("/icon/edit.svg")}></img>
                {/* <img src="/icon/edit.svg" /> */}
              </a>
              <a onClick={() => this.onModal("delete", true, item)}>
                <img src={Api.absoluteUrl("/icon/delete.svg")}></img>
                {/* <img src="/icon/delete.svg" /> */}
              </a>
            </div>
          ),
          sorter: () => null,
        },
      ],
      filter: "",
      filteredData: [],
      dateFormatList: ["DD/MM/YYYY", "DD/MM/YY"],
      processType: null,
    };
  }

  async componentDidMount() {
    this.setJobCategory();
  }

  async setJobCategory() {
    const data = await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
    });
    if (data.data.result.code === "P") {
      console.log(data.data.data.result_data);
      this.setState({
        data: data.data.data.result_data,
        filteredData: data.data.data.result_data,
        loading: false,
        visible: false,
      });
    } else {
    }
  }

  NotiModal() {
    const { processType } = this.state;
    if (processType === "add") {
      return "Successfully Added Job Category";
    } else if (processType === "edit") {
      return "Successfully Edited Job Category";
    } else if (processType === "delete") {
      return "Successfully Deleted Job Category";
    }
  }

  async handleSubmit(values) {
    const { modal_item } = this.state;
    var form = {};

    if (this.state.processType === "add") {
      form["create_by"] = Cookies.get("userId");
      form["update_by"] = Cookies.get("userId");
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["job_category_id"] = 0;
      form["job_category_name"] = values.job_category_name;
      form["effective_date"] = values.effective_date;
      form["expire_date"] = values.expire_date;
      form["is_active"] = 1;
      form["project_id"] = Cookies.get("project_id");
      form["icon_name"] = "";
      await Api.post("update_job_category", form).then((val) => {
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });
      //reloadin data
      await Api.post("get_job_category_V2", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_category_id: null,
        is_active: 1,
        date_active: 1,
      }).then((val) => {
        if (val.data.result.code === "P") {
          this.setState({
            data: val.data.data.result_data,
            filteredData: val.data.data.result_data,
            loading: false,
            visible: false,
          });
        }
      });
    } else if (this.state.processType === "edit") {
      form["create_by"] = Cookies.get("userId");
      form["update_by"] = Cookies.get("userId");
      form["company_id"] = Cookies.get("companyid");
      form["operator_id"] = Cookies.get("operator_id");
      form["job_category_id"] = modal_item.job_category_id;
      form["job_category_name"] = values.job_category_name;
      form["effective_date"] = moment(values.effective_date).format("YYYY-MM-DD HH:mm");
      form["expire_date"] = moment(values.expire_date).format("YYYY-MM-DD HH:mm");
      form["is_active"] = 1;
      form["project_id"] = Cookies.get("project_id");
      form["icon_name"] = "";

      console.log(form);

      await Api.post("update_job_category", form).then((val) => {
        console.log(val);
        if (val.data.result.code !== "F") {
          this.OnViewApprove(this.renderApproveButtonModal());
          this.formRef.current.resetFields();
        } else {
          this.OnViewReject(this.renderRejectButtonModal());
        }
      });

      //reloadin data
      await Api.post("get_job_category_V2", {
        company_id: Cookies.get("companyid"),
        operator_id: Cookies.get("operator_id"),
        project_id: Cookies.get("project_id"),
        job_category_id: null,
        is_active: 1,
        date_active: 1,
      }).then((val) => {
        console.log(val);
        if (val.data.result.code === "P") {
          this.setState({
            data: val.data.data.result_data,
            filteredData: val.data.data.result_data,
            loading: false,
            visible: false,
          });
        }
      });
    }
  }

  async handleDelete() {
    const { modal_item } = this.state;
    var form = {};

    form["create_by"] = Cookies.get("userId");
    form["update_by"] = Cookies.get("userId");
    form["company_id"] = Cookies.get("companyid");
    form["operator_id"] = Cookies.get("operator_id");
    form["job_category_id"] = modal_item.job_category_id;
    form["job_category_name"] = modal_item.job_category_name;
    form["effective_date"] = moment(modal_item.effective_date).format("YYYY-MM-DD HH:mm");
    form["expire_date"] = moment(modal_item.expire_date).format("YYYY-MM-DD HH:mm");
    form["is_active"] = 0;
    form["project_id"] = Cookies.get("project_id");
    form["icon_name"] = "";

    console.log(form);

    await Api.post("update_job_category", form).then((val) => {
      console.log(val);
      if (val.data.result.code !== "F") {
        this.OnViewApprove(this.renderApproveButtonModal());
      } else {
        this.OnViewReject(this.renderRejectButtonModal());
      }
    });

    //reloadin data
    await Api.post("get_job_category_V2", {
      company_id: Cookies.get("companyid"),
      operator_id: Cookies.get("operator_id"),
      project_id: Cookies.get("project_id"),
      job_category_id: null,
      is_active: 1,
      date_active: 1,
    }).then((val) => {
      console.log(val);
      if (val.data.result.code === "P") {
        this.setState({
          data: val.data.data.result_data,
          filteredData: val.data.data.result_data,
          loading: false,
          visible: false,
        });
      }
    });
  }

  onModal(mode, visible, item) {
    console.log(mode);

    if (mode === "edit") {
      console.log(mode);
      console.log(visible);
      console.log(item);
      this.setState({
        visible: visible,
        processType: mode,
        modal_item: item,
      });
      {
        setTimeout(() => {
          this.formRef.current.setFieldsValue({
            job_category_name: item.job_category_name,
            effective_date:  moment(item.effective_date),
            expire_date:  moment(item.expire_date),
            is_active: item.is_active,
          });
        }, 0);
      }

      this.setState({
        data_item: item,
      });
    } else if (mode === "delete") {
      console.log(mode);
      console.log(visible);
      console.log(item);
      this.setState({
        modal_item: item,
        visible_delete: visible,
        processType: mode,
      });
    } else if (mode === "add") {
      this.setState({
        processType: mode,
        visible: visible,
      });
    }
    // }
  }

  handleChange = (e) => {
    let currentList = [];
    let newList = [];
    this.setState({ filter: e.target.value });
    if (e.target.value !== "") {
      currentList = this.state.data;
      newList = currentList.filter((item) => {
        return item.job_category_name.toLowerCase().includes(e.target.value);
      });
    } else {
      newList = this.state.data;
    }
    this.setState({
      filteredData: newList,
    });
  };

  saveFormRef = (form) => {
    this.form = form;
    console.log("saveFormRef form");
    console.log(form);
  };

  //Close the modal
  ModalClosed = () => {
    this.setState({
      visible: false,
      visible_delete: false,
    });
  };

  handleDateStartEnd = ( obj , name) => {
    this.state.form[name] = moment(obj).format("YYYY-MM-DD HH:mm:ss");
  }

  renderModalJobButton() {
    const { visible, title, mode, loading, dateFormatList } = this.state;
    const dateFormat = 'YYYY-MM-DD';
    // console.log("data_item");
    // console.log(this.state.data_item);
    // console.log("data_dynamic");
    // console.log(this.state.data_item.data_dynamic);
    return (
      <Modal
        title={
          <span className="font-mont-b fs-16 c-blue text-uppercase">
            {mode} {title}
          </span>
        }
        closable={true}
        visible={visible}
        footer={false}
        onCancel={this.ModalClosed}
        destroyOnClose={true}
      >
        <Spin spinning={loading}>
          <Form
            onFinish={(mode, values) => this.handleSubmit(mode, values)}
            layout="vertical"
            initialValues={{
              effective_date: moment(new Date(), dateFormat),
              expire_date:  moment(new Date(), dateFormat),

            }}
            ref={this.formRef}
          >
            {mode == "edit" ? (
              <Form.Item
                name="is_active"
                label="Status"
                rules={[{ required: true, message: "Status is required" }]}
              >
                <Radio.Group>
                  <Radio value={1}>
                    <span className="font-thai-r fs-18">Active</span>
                  </Radio>
                  <Radio value={0}>
                    <span className="font-thai-r fs-18">Inactive</span>
                  </Radio>
                </Radio.Group>
              </Form.Item>
            ) : null}

            <Form.Item
              name="job_category_name"
              label="Job Category Name"
              rules={[
                { required: true, message: "Job category name is required" },
              ]}
            >
              <Input
                className="inputfile"
                type="text"
                size="large"
                placeholder="Please Input"
   
              />
            </Form.Item>
            <Form.Item
              name="effective_date"
              label="Effective Date"
              rules={[
                {
                  required: true,
                  message: "Effective Date are required",
                },
              ]}
            >
              <DatePicker
                className="inputfile"
                type="text"
                size="large"
                style={{ width: "70%" }}
                name="size"
                format={dateFormatList}
                def
                // onChange={(value) => this.handleDateStartEnd( value , 'effective_date' )}
              // type_sc="size"
              ></DatePicker>
            </Form.Item>
            <Form.Item
              name="expire_date"
              label="Expire Date"
              rules={[
                {
                  required: true,
                  message: "Expire Date are required",
                },
              ]}
            >
              <DatePicker
                className="inputfile"
                type="text"
                size="large"
                style={{ width: "70%" }}
                name="size"
                format={dateFormatList}
                def
                // onChange={(value) => this.handleDateStartEnd( value , 'expire_date' )}
              // type_sc="size"
              ></DatePicker>
            </Form.Item>

            <Form.Item className="mb-0 text-center">
              <button
                type="reset"
                onClick={() => this.setState({ visible: false })}
                className="btn btn-secondary"
              >
                Cancel
              </button>
              <button className="btn btn-success">Submit</button>
            </Form.Item>
          </Form>
        </Spin>
      </Modal>
    );
  }

  // Opening approve
  OnViewApprove() {
    this.setState({
      visible_approve: true,
    });
  }

  // Open Failed Modal
  OnViewReject() {
    this.setState({
      visible_reject: true,
    });
  }

  renderDelete() {
    const { loading_modal_delete, visible_delete } = this.state;
    // Add Material Form
    return (
      <Fragment>
        <Modal
          title={"Delete Job Category"}
          centered={true}
          visible={visible_delete}
          footer={false}
          destroyOnClose={true}
          onCancel={this.ModalClosed}
        >
          <Spin spinning={loading_modal_delete}>
            {/* <Form onFinish={this.handleAdd} ref={this.formEditRef} layout="vertical"> */}

            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")}></img>
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")}></img>
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  Are you sure?
                </span>
              </div>
            </div>

            <div
              style={{
                fontFamily: "MontserratM",
                fontWeight: "bold",
                color: "#0500A3",
              }}
            >
              <div>
                <div className="row">
                  <div className="col text-center justify-content-between">
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.setState({ visible_delete: false })}
                      className="btn btn-secondary"
                    >
                      No
                    </button>
                    <button
                      type="reset"
                      style={{ width: "120px" }}
                      onClick={() => this.handleDelete()}
                      className="btn btn-danger"
                    >
                      Yes
                    </button>
                  </div>
                </div>
              </div>
            </div>
            {/* </Form> */}
          </Spin>
        </Modal>
      </Fragment>
    );
  }

  //Approve Modal
  renderApproveButtonModal() {
    const { visible_approve } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_approve}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")}></img>
                ) : (
                  <img src={Api.absoluteUrl("/icon/approve_check.svg")}></img>
                  // <img src={"./icon/approve_check.svg"} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 20px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.NotiModal()}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({
                      visible_approve: false,
                      visible_delete: false,
                      visible: false,
                    })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  //Reject modal
  renderRejectButtonModal() {
    const { visible_reject } = this.state;
    return (
      <Fragment>
        <Modal
          centered
          visible={visible_reject}
          footer={null}
          closable={false}
          width={300}
          bodyStyle={{
            paddingTop: "0",
            paddingLeft: "15px",
            paddingRight: "15px",
            paddingBottom: "0",
          }}
        >
          <div className="p-3">
            <div className="row">
              <div className="col text-center justify-content-between">
                {window.location.hostname == "localhost" ? (
                  <img src={Api.absoluteUrl("/icon/reject.svg")}></img>
                ) : (
                  // <img src={"/icon/reject.svg"} />
                  <img src={Api.absoluteUrl("/icon/reject.svg")}></img>
                  // <img src={"./icon/reject.svg"} />
                )}
              </div>
            </div>

            <div className="row" style={{ margin: "20px 10px 40px 10px" }}>
              <div className="col text-center justify-content-between">
                <span
                  style={{
                    fontFamily: "MontserratM",
                    fontWeight: "bold",
                    color: "#0500A3",
                  }}
                >
                  {this.state.error_log != null &&
                    this.state.error_log.includes(
                      "already have material_code:"
                    ) ? (
                    <>
                      <span style={{ color: "red" }}>
                        Add Permission Failed.
                      </span>
                      <br></br>
                      <span style={{ color: "red" }}>
                        {this.state.error_log}
                      </span>
                    </>
                  ) : (
                    <span style={{ color: "red" }}>
                      Submission Failed, Please Check Your Input
                    </span>
                  )}
                </span>
              </div>
            </div>

            <div className="row">
              <div className="col text-center justify-content-between">
                <button
                  type="reset"
                  style={{ height: "30px", width: "100px" }}
                  onClick={() =>
                    this.setState({ visible_reject: false, visible: false })
                  }
                  className="btn btn-warning"
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </Modal>
      </Fragment>
    );
  }

  render() {
    const { loading, title, filteredData, columns, filter } = this.state;
    // console.log(filteredData);
    return loading === false ? (
      <div>
        {this.state.visible_approve ? this.renderApproveButtonModal() : null}
        {this.state.visible_reject ? this.renderRejectButtonModal() : null}
        {this.renderModalJobButton()}
        {this.renderDelete()}

        <span className="font-mont-r fs-12">Basic Data</span>
        <h3 className="font-mont-sb fs-18 c-blue">{title}</h3>
        <div className="d-flex justify-content-between m-3">
          <Input
            placeholder="Search Job Category Name"
            value={filter}
            style={{ width: 200 }}
            onChange={this.handleChange}
          />

          <Ui.ExportCSV csvData={filteredData} fileName="test" />

          <button
            className="btn btn-warning"
            onClick={() => this.onModal("add", true)}
          >
            <img src={Api.absoluteUrl("/icon/plus.svg")}></img>
            {/* <img src="/icon/plus.svg" className="mr-2" /> */}
            Add {title}
          </button>
        </div>
        <Table
          rowKey="job_category_id"
          columns={columns}
          dataSource={filteredData}
        />
        {/* {this.renderModal()} */}
      </div>
    ) : null;
  }
}

export default JobCategory;
